import { createPersistedQueryLink } from "apollo-angular/persisted-queries";
import { sha256 } from "../client";

export const persistedQueryLink = createPersistedQueryLink({ sha256 });
